var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE4EquipmentRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 49.75V60H40v-6.23L49.78 43H52a7 7 0 017 6.75zM28.62 25.13a10 10 0 1018.76 0H28.62zM31.44 43l7.07 7.55L45.64 43h-14.2zm9.29-29l2.33-2.61a10.52 10.52 0 00-10.48.2L34.77 14h5.96zM25 43a7 7 0 00-7 6.74V60h19v-6.23L27.22 43H25zm26-21v-1.86l-2.21-1.24a12.16 12.16 0 00-3.31-5.74l-3.37 4H33.4l-3.17-3.66a12.11 12.11 0 00-3 5.57L25 20.14V22h26z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E4_Equipment_room.0e12c4bb.svg";
export { SvgE4EquipmentRoom as ReactComponent };